import { Component, input, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { TimeSlot } from '../../nexpe.model';

@Component({
  selector: 'app-timeslot-row',
  imports: [TranslateModule],
  templateUrl: './timeslot-row.component.html',
  styleUrl: './timeslot-row.component.scss',
})
export class TimeslotRowComponent {
  timeSlot = input.required<TimeSlot>();
  index = input.required<number>();
  timeSlotChange = output<{ index: number; timeSlot: TimeSlot }>();
  deleteSlot = output<number>();

  onFieldChange(field: keyof TimeSlot, value: string): void {
    const numValue = field === 'delayedCutOffHours' && value === '' ? null : Number(value);
    this.timeSlotChange.emit({
      index: this.index(),
      timeSlot: { ...this.timeSlot(), [field]: numValue },
    });
  }

  onDelete(): void {
    this.deleteSlot.emit(this.index());
  }
}
